<!-- Sidepanel Right Search Customer -->
<aside [ngClass]="{'active':  bundleDealerService.isPGESearchModalOpen }" class="footer-sidepanel footer-sidepanel--customer-search">
    <div class="footer-sidepanel__header">
        <h5><i class="fa-light fa-search"></i>Search Customer</h5>
        <a (click)="bundleDealerService.closePgeSearchModal()"><i class="fa-light fa-xmark"></i></a>
    </div>
    <div class="footer-sidepanel__content">


        <form [formGroup]="bundleDealerService.searchCustomerForm" class="form-fields form-fields--secondary">
            <div class="flex-row flex-row--compact">
                <div class="flex-col-xs-3">
                    <div class="single-input-field-wrapper">
                        <label for="fname" class="form-fields__label">First
                            name</label>
                        <input formControlName="firstName" type="text" id="fname" name="fname" size="30" class="form-fields__input">
                        <!-- <div class="validation validation--error">First name is
                            not
                            entered.
                        </div> -->
                    </div>
                </div>
                <div class="flex-col-xs-3">
                    <div class="single-input-field-wrapper">
                        <label for="lastName" class="form-fields__label">Last
                            name</label>
                        <input formControlName="lastName" type="text" id="lastName" name="lastName" size="30"  class="form-fields__input">
                        <!-- <div class="validation validation--error">Last name is
                            not
                            entered.
                        </div> -->
                    </div>
                </div>
                <div class="flex-col-xs-6">
                    <div class="single-input-field-wrapper">
                        <label for="street" class="form-fields__label">Street</label>
                        <input formControlName="street" type="text" id="street" name="street" size="30" placeholder="" class="form-fields__input">
                        <!-- <div class="validation validation--error">Invalid Street                               entered.
                        </div> -->
                    </div>
                </div>
                <div class="flex-col-xs-3">
                    <div class="single-input-field-wrapper">
                        <label for="city" class="form-fields__label">City</label>
                        <input formControlName="city" type="text" id="city" name="city" size="30" placeholder="" class="form-fields__input">
                    </div>
                </div>
                <div class="flex-col-xs-3">
                    <div class="single-input-field-wrapper">
                        <label for="state" class="form-fields__label">State</label>
                        <input formControlName="state" type="text" id="state" name="state" size="30" placeholder="" class="form-fields__input">
                    </div>
                </div>
                <div class="flex-col-xs-3">
                    <div class="single-input-field-wrapper">
                        <label for="zip" class="form-fields__label">Zip</label>
                        <input formControlName="zip" type="text" id="zip" name="zip" size="30" placeholder="" class="form-fields__input">
                    </div>
                </div>
                <div class="flex-col-xs-3">
                    <div class="single-input-field-wrapper">
                        <label for="search" class="form-fields__label is-invisible">Search button</label>
                        <a (click)="onCustomerSearch()" class="single-button--with-bg"><i class="fa-light fa-search"></i> Search</a>
                    </div>
                </div>
            </div>
        </form>

        <div class="flex-row" >
            <div class="flex-col-xs-12">
                <table class="table-module table-module--minimal table-module--minimal-secondary table-module--bordered">
                    <thead>
                        <tr>
                            <th>First Name</th>
                            <th>Last Name</th>
                            <th>Addresss</th>
                            <th class="is-invisible">Search</th>
                            
                        </tr>
                    </thead>
                    <tbody *ngIf="bundleDealerService.customersData.length > 0; else noData">
                        <tr *ngFor="let c of bundleDealerService.customersData;let i = index">
                            <td>{{c.customer.firstName}}</td>
                            <td>{{c.customer.lastName}}</td>
                            <td>{{c.customer.streetAddress}}</td>
                            <td><a (click)="bundleDealerService.handleSelectedCustomer(c)" class="single-button--with-bg">Select</a></td>
                            
                        </tr> 
                    </tbody>
                    <ng-template #noData>
                        <tbody>
                          <tr>
                            <td colspan="4" align="center" class="text-x-center">
                              <i class="no-data__icon fa-thin fa-users"></i>
                              No data available.
                            </td>
                          </tr>
                        </tbody>
                      </ng-template>
                </table>
            </div>
        </div>

    </div>
</aside>